import React, { createContext, useContext, useState } from "react";
import { getLocaleMessages, defaultLocale } from "../locales";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [currentLocale, setCurrentLocale] = useState(defaultLocale);
  const messages = getLocaleMessages(currentLocale);

  const value = {
    locale: currentLocale,
    messages,
    setLocale: setCurrentLocale,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
